"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _luggage = require("./luggage.factory");
var _frequentFlyer = _interopRequireDefault(require("./frequent-flyer.factory"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _split3 = _interopRequireDefault(require("lodash/split"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _constants = require("../constants");
function ssrFactory(_ref) {
  var _ssr$frequentFlyer, _ssr$meal, _ssr$specialRequest, _ssr$seat;
  var ssr = _ref.ssr,
    $currency = _ref.$currency,
    productId = _ref.productId;
  var _split2 = (0, _split3.default)(ssr === null || ssr === void 0 ? void 0 : (_ssr$frequentFlyer = ssr.frequentFlyer) === null || _ssr$frequentFlyer === void 0 ? void 0 : _ssr$frequentFlyer.membershipNumber, _constants.FREQUENT_FLYER_SEPARATOR),
    operatorCode = _split2[0],
    number = _split2[1];
  var luggage = (0, _map2.default)(ssr === null || ssr === void 0 ? void 0 : ssr.luggage, function (luggage) {
    return (0, _luggage.selectedLuggageFactory)({
      luggage: luggage,
      $currency: $currency
    });
  });
  return {
    seatIndex: ssr === null || ssr === void 0 ? void 0 : ssr.seatIndex,
    luggage: (0, _keyBy2.default)(luggage, 'id'),
    frequentFlyer: (0, _frequentFlyer.default)({
      operatorCode: operatorCode,
      number: number
    }),
    meal: (_ssr$meal = ssr === null || ssr === void 0 ? void 0 : ssr.meal) !== null && _ssr$meal !== void 0 ? _ssr$meal : {},
    specialRequest: (_ssr$specialRequest = ssr === null || ssr === void 0 ? void 0 : ssr.specialRequest) !== null && _ssr$specialRequest !== void 0 ? _ssr$specialRequest : {},
    seat: (_ssr$seat = ssr === null || ssr === void 0 ? void 0 : ssr.seat) !== null && _ssr$seat !== void 0 ? _ssr$seat : [],
    productId: productId
  };
}
var _default = exports.default = ssrFactory;